import React from 'react';
import './styles.css';
import Alcat from './alcat/Alcat';
import SpecializedTesting from './profiles/SpecializedTesting';

const CSSTestSelection = ({ orderableItem, selectedComponents, onSelection, children }) => {
	return (
		<div>
			{children}
			{selectedComponents?.length > 0 && <ClearSelectionsButton onSelection={onSelection} />}

			<Alcat orderableItem={orderableItem} onSelection={onSelection} selectedComponents={selectedComponents} />

			<SpecializedTesting
				orderableItem={orderableItem}
				onSelection={onSelection}
				selectedComponents={selectedComponents}
			/>
		</div>
	);
};

const ClearSelectionsButton = ({ onSelection }) => {
	if (!onSelection) {
		return null;
	}
	const clearSelections = () => {
		onSelection([]);
	};

	return (
		<button
			className="btn-link"
			type="button"
			style={{
				position: 'absolute',
				right: '0',
				top: '0',
				minWidth: 'fit-content',
				display: 'inline',
				margin: '6px',
				fontSize: '14px'
			}}
			onClick={clearSelections}
		>
			<span>Clear Selections</span>
		</button>
	);
};

export default CSSTestSelection;
